import React, { useState, useEffect } from 'react';
import L from 'leaflet';

export const isChristmasTime = () => {
    const today = new Date();
    const currentMonth = today.getMonth(); // 0-11
    const currentDay = today.getDate();

    // Dezember (Monat 11)
    if (currentMonth === 11 && currentDay >= 1) {
      return true;
    }
    // Januar (Monat 0)
    if (currentMonth === 0 && currentDay <= 1) {
      return true;
    }
    return false;
};

export const secretWorkshopIcon = new L.Icon({
    iconUrl: 'https://cdn-icons-png.flaticon.com/512/2329/2329762.png',
    iconSize: [35, 35],
    iconAnchor: [17, 35],
    popupAnchor: [0, -35],
});


const ChristmasElf = ({ setElfClicked }) => {
  const [showElf, setShowElf] = useState(false);
  const [elfPosition, setElfPosition] = useState({});
  const [elfSide, setElfSide] = useState('left');

  useEffect(() => {
    if (!isChristmasTime()) {
      return;
    }

    const interval = setInterval(() => {
      if (Math.random() < 0.3) { 
        setShowElf(true);
        const side = Math.floor(Math.random() * 4);
        let pos = {};
        let sideName = 'left';
        switch (side) {
          case 0: // top
            pos = { top: '30px', left: `${Math.random() * 100}%` };
            sideName = 'top';
            break;
          case 1: // right
            pos = { top: `${Math.random() * 100}%`, right: '30px' };
            sideName = 'right';
            break;
          case 2: // bottom
            pos = { bottom: '50px', left: `${Math.random() * 100}%` };
            sideName = 'bottom';
            break;
          case 3: // left
          default:
            pos = { top: `${Math.random() * 100}%`, left: '30px' };
            sideName = 'left';
            break;
        }
        setElfPosition(pos);
        setElfSide(sideName);

        setTimeout(() => {
          setShowElf(false);
        }, 10000); 
      }
    }, 15000); 

    return () => clearInterval(interval);
  }, []);

  const handleElfClick = () => {
    setElfClicked(true);
    setShowElf(false);
    alert("Hilf mir, die Eis-Werkstatt des Weihnachtsmanns zu finden! Sie ist irgendwo in der Arktis versteckt.");
  };

  if (!showElf) {
    return null;
  }

  return (
    <div
      className={`christmas-elf elf-from-${elfSide}`}
      style={{
        position: 'absolute',
        zIndex: 1001,
        cursor: 'pointer',
        ...elfPosition
      }}
      onClick={handleElfClick}
      title="Psst... Klick mich!"
    >
      <img src="/assets/christmas_elf.png" alt="Christmas Elf" style={{ width: '80px', height: '80px' }}/>
    </div>
  );
};

export default ChristmasElf;
